export default "__VITE_ASSET__a2b8564a__"